import { t } from "i18next";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import TypographyText from "../../TypographyText/TypographyText";
import "./PhoneNumberInput.css";

export default function PhoneNumberInput({
  phoneNumber,
  setPhoneNumber,
  label,
  helperText,
  disabled = false,
  size = "sm",
}: {
  phoneNumber: string | undefined;
  setPhoneNumber: (phone: string | undefined) => void;
  label?: string;
  helperText?: string;
  disabled?: boolean;
  size?: "xs" | "sm" | "md";
}) {
  const isValid = phoneNumber ? isValidPhoneNumber(phoneNumber) : true;
  let border; //Needs to be undefined for rest of styles to apply
  let outline;
  let backgroundColor = "var(--color-base-white)";
  if (isValid === false) {
    border = "1px solid var(--error-300)";
    outline = "4px solid var(--error-100)";
  }
  if (disabled) backgroundColor = "var(--gray-50)";

  const sizeMapPadding = {
    xs: "4px 11px",
    sm: "6px 11px",
    md: "8px 13px",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "6px",
      }}
    >
      <TypographyText size="sm" weight="medium" css={{ color: "var(--gray-700)" }}>
        {label ? label : t("main.phoneNumber")}
      </TypographyText>
      <PhoneInput
        defaultCountry="NO"
        placeholder={phoneNumber ? phoneNumber : t("main.fillInPhoneNumber")}
        value={phoneNumber}
        onChange={setPhoneNumber}
        disabled={disabled}
        style={{
          padding: sizeMapPadding[size],
          border: border,
          outline: outline,
          borderRadius: "8px",
          backgroundColor: backgroundColor,
        }}
      />
      {helperText && isValid && (
        <TypographyText size="xs" weight="regular" css={{ color: "var(--gray-600)" }}>
          {helperText}
        </TypographyText>
      )}
      {!isValid && (
        <TypographyText size="xs" weight="regular" css={{ color: "var(--error-500)" }}>
          {t("main.invalidPhoneNumber")}
        </TypographyText>
      )}
      {!helperText && isValid && <div style={{ height: "18px" }} />}
    </div>
  );
}
